// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { PortalBaseEntity } from '../portal-base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JobsDataProperties extends PortalBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  jobId!: number;
  dataPropertyId!: number;
}

